import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { getPropertyById, updateProperty, uploadPropertyImages } from '../services/propertyService';
import { useAuth } from '../context/AuthContext';

import PropertyHeader from '../modules/PropertyHeader';
import PropertyAmenities from '../modules/PropertyAmenities';
import PropertyInfo from '../modules/PropertyInfo';
import Seo from "../components/seo/Seo";

// Property
const normalizeFormFromBackend = (data) => ({
  ...data,

  // 🔥 ADAUGĂ ASTEA
  phone: data.phone || '',
  email: data.email || '',
  address: data.address || '',
  county: data.county || '',
  locality: data.locality || '',

  amenities: {
    generalAmenities: data.generalAmenities || [],
    agroAmenities: data.agroAmenities || []
  },
  rooms: data.rooms || {},
  roomsPrice: data.roomsPrice || {},
  roomsAvailable: data.roomsAvailable || {},
  images: data.images || []
});

const countyToRegion = {
  'Alba': 'Transilvania', 'Arad': 'Crisana', 'Arges': 'Muntenia', 'Bacau': 'Moldova',
  'Bihor': 'Crisana', 'Bistrita-Nasaud': 'Transilvania', 'Botosani': 'Moldova',
  'Brasov': 'Transilvania', 'Braila': 'Muntenia', 'Buzau': 'Muntenia',
  'Caras-Severin': 'Banat', 'Calarasi': 'Muntenia', 'Cluj': 'Transilvania',
  'Constanta': 'Dobrogea', 'Covasna': 'Transilvania', 'Dambovita': 'Muntenia',
  'Dolj': 'Oltenia', 'Galati': 'Moldova', 'Giurgiu': 'Muntenia', 'Gorj': 'Oltenia',
  'Harghita': 'Transilvania', 'Hunedoara': 'Transilvania', 'Ialomita': 'Muntenia',
  'Iasi': 'Moldova', 'Ilfov': 'Muntenia', 'Maramures': 'Maramures', 'Mehedinti': 'Oltenia',
  'Mures': 'Transilvania', 'Neamt': 'Moldova', 'Olt': 'Oltenia', 'Prahova': 'Muntenia',
  'Satu Mare': 'Crisana', 'Salaj': 'Crisana', 'Sibiu': 'Transilvania', 'Suceava': 'Bucovina',
  'Teleorman': 'Muntenia', 'Timis': 'Banat', 'Tulcea': 'Dobrogea', 'Vaslui': 'Moldova',
  'Valcea': 'Oltenia', 'Vrancea': 'Moldova'
};

export default function Property() {
  const { id } = useParams();
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const editable = location.state?.editable || false;
  const canEdit = editable && user?.role === 'host';
  const isHost = user?.role === 'host';
  const guest = user?.role === 'guest';

  const [prop, setProp] = useState(null);
  const [form, setForm] = useState({
    phone: '',
    email: '',
    address: '',
    county: '',
    locality: '',
    amenities: {},
    rooms: {},
    roomsPrice: {},
    roomsAvailable: {},
    checkIn: '',
    checkOut: '',
    adults: 1,
    children: 0,
    childrenAges: [],
    childRules: [],
    images: [],
    freeCancellation: false,
    freeCancellationDays: 0
  });

  useEffect(() => {
    console.log("🟢 FORM UPDATED LAT LNG:", form.lat, form.lng);
  }, [form.lat, form.lng]);

  const [newImages, setNewImages] = useState([]);
  const [editMode, setEditMode] = useState(false);

  // totalPrice calculat local
  const totalPrice = Object.keys(form.rooms || {}).reduce((sum, room) => {
    const qty = Number(form.rooms?.[room] || 0);
    const price = Number(form.roomsPrice?.[room] || 0);
    return sum + qty * price;
  }, 0);
  const mealPrice = form.selectedMeal && form.mealOptions
    ? (form.mealOptions[form.selectedMeal] || 0)
    : 0;
  const totalPriceWithMeal = totalPrice + mealPrice;
  const discountAmount = form.discount ? (totalPriceWithMeal * form.discount / 100) : 0;
  const finalPrice = totalPriceWithMeal - discountAmount;

  const handleBooking = () => {
    const bookingData = {
      propertyId: id,
      checkIn: form.checkIn,
      checkOut: form.checkOut,
      adults: form.adults,
      children: form.children,
      childrenAges: form.childrenAges,
      rooms: form.rooms,
      roomsPrice: form.roomsPrice,
      roomsAvailable: form.roomsAvailable,
      selectedMeal: form.selectedMeal,
      mealOptions: form.mealOptions,
      discount: form.discount,
      totalPrice: totalPriceWithMeal,
      discountAmount,
      finalPrice
    };
    navigate(`/booking/${id}`, { state: { bookingData } });
  };

  // Încarcă proprietatea
  useEffect(() => {
    const loadProperty = async () => {
      const property = await getPropertyById(id);
      setProp(property);

      console.log("🔥 BACKEND PROPERTY:", property);
      console.log("🔥 BACKEND LAT LNG:", property?.lat, property?.lng);

      const normalized = normalizeFormFromBackend(property);
      setForm(normalized);

      console.log("🟡 NORMALIZED FORM:", normalized);
      console.log("🟡 FORM LAT LNG:", normalized.lat, normalized.lng);

    };
    loadProperty();
  }, [id]);

  if (!prop) return <div>Se încarcă...</div>;

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (!isHost && !guest) return;

    if (type === 'checkbox' && (name === 'generalAmenities' || name === 'agroAmenities')) {
      setForm(prev => {
        const current = Array.isArray(prev.amenities?.[name]) ? prev.amenities[name] : [];
        const updated = checked ? [...current, value] : current.filter(a => a !== value);
        return { ...prev, amenities: { ...prev.amenities, [name]: updated } };
      });
    } else if (type === 'checkbox') {
      setForm(prev => ({ ...prev, [name]: checked }));
    } else if (name.startsWith('rooms.')) {
      const roomType = name.split('.')[1];
      setForm(prev => ({ ...prev, rooms: { ...prev.rooms, [roomType]: parseInt(value) || 0 } }));
    } else if (name === 'other') {
      setForm(prev => ({ ...prev, amenities: { ...prev.amenities, other: value } }));
    } else if (name === 'children') {
      const numChildren = Number(value);
      setForm(prev => {
        let ages = [...(prev.childrenAges || [])];
        while (ages.length < numChildren) ages.push(3);
        while (ages.length > numChildren) ages.pop();
        return { ...prev, children: numChildren, childrenAges: ages };
      });
    } else if (name === 'childrenAges') {
      const index = Number(e.target.dataset.index);
      const val = Number(value);
      setForm(prev => {
        const ages = [...prev.childrenAges];
        ages[index] = val;
        return { ...prev, childrenAges: ages };
      });
    } else if (
      name === 'phone' ||
      name === 'email' ||
      name === 'address' ||
      name === 'county' ||
      name === 'locality' ||
      name === 'lat' ||
      name === 'lng'
    ) {
      setForm(prev => ({
        ...prev,
        [name]: value
      }));
    } else {
      setForm(prev => ({ ...prev, [name]: type === 'number' ? Number(value) : value }));
    }
  };

  const handleAddImages = (e) => {
    if (!canEdit || !editMode) return;
    const files = Array.from(e.target.files);
    if ((form.images.length + newImages.length + files.length) > 25) {
      alert('Poți încărca maxim 25 de imagini');
      return;
    }
    setNewImages(prev => [...prev, ...files]);
  };

  const handleRemoveExistingImage = (i) => {
    if (!canEdit || !editMode) return;
    setForm(prev => ({ ...prev, images: prev.images.filter((_, idx) => idx !== i) }));
  };

  const handleRemoveNewImage = (i) => {
    if (!canEdit || !editMode) return;
    setNewImages(prev => prev.filter((_, idx) => idx !== i));
  };

  const handleSave = async () => {
    if (!canEdit) return alert('Nu ai permisiunea să editezi această proprietate.');

    console.log('FORM BEFORE SAVE:', form);

    let uploadedImages = [];
    if (newImages.length) {
      const formData = new FormData();
      newImages.forEach(img => formData.append('images', img));
      const res = await uploadPropertyImages(id, formData, token);
      uploadedImages = res.images || [];
    }

    const payload = {
      ...form,

      images: [...form.images, ...uploadedImages],
      generalAmenities: form.amenities?.generalAmenities || [],
      agroAmenities: form.amenities?.agroAmenities || [],
      roomsAvailable: form.roomsAvailable || {}
    };

    console.log('PAYLOAD TO UPDATE:', payload);

    try {
      const updated = await updateProperty(id, payload, token);

      console.log('UPDATED PROPERTY FROM BACKEND:', updated);

      setProp(updated);
      setForm(normalizeFormFromBackend(updated));

      setNewImages([]);
      setEditMode(false);
      alert('Proprietate actualizata!');
    } catch (err) {
      console.error(err);
      alert('A apărut o eroare la salvare.');
    }
  };

  const handleCancel = () => {
    setForm(normalizeFormFromBackend(prop));
    setNewImages([]);
    setEditMode(false);
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '1rem' }}>
      <Seo pageType="proprietate" data={prop} />

      {canEdit && !editMode && (
        <button
          onClick={() => setEditMode(true)}
          style={{ marginBottom: '1rem', background: '#006d77', color: 'white', padding: '0.5rem 1rem' }}
        >
          Editează
        </button>
      )}

      <PropertyHeader
        form={form}
        editMode={editMode && canEdit}
        isHost={canEdit}
        newImages={newImages}
        onChange={handleChange}
        onAddImages={handleAddImages}
        onRemoveExistingImage={handleRemoveExistingImage}
        onRemoveNewImage={handleRemoveNewImage}
      />

      <PropertyAmenities
        property={prop}
        amenities={form.amenities || {}}
        editMode={editMode && isHost}
        isHost={isHost}
        guestMode={guest}
        form={form}
        onChange={handleChange}
      />

      <PropertyInfo
        phone={form.phone}
        email={form.email}
        address={form.address}
        county={form.county}
        locality={form.locality}
        lat={form.lat}
        lng={form.lng}
        reviews={form.reviews}
        userRole={user?.role}
        editMode={editMode}
        onChange={handleChange}
      />

      {(guest || user?.role === 'admin') && (
        <button
          onClick={handleBooking}
          style={{
            marginTop: '1rem',
            padding: '0.4rem 1rem',
            backgroundColor: '#006d77',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontWeight: '500'
          }}
        >
          Rezervă
        </button>
      )}

      {canEdit && editMode && (
        <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem' }}>
          <button
            onClick={handleSave}
            style={{ background: '#dd4124', color: 'white', padding: '0.5rem 1rem' }}
          >
            Salvează
          </button>
          <button
            onClick={handleCancel}
            style={{ background: '#ccc', color: '#333', padding: '0.5rem 1rem' }}
          >
            Renunță
          </button>
        </div>
      )}
    </div>
  );
}